import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '../../atoms/Skeleton';
import { ProductCardSkeleton } from '../ProductCard';
import { COLL_ROW_PRODUCTS } from './CollectionRow';
import './collectionRow.css';

/* CollectionRowSkeleton — the shape of `.cl-row` while it loads.
   It reuses the row's own classes (30px padding, hairline, 18px head gap,
   five-across grid), so the row cannot change shape without its skeleton
   following. */
export default function CollectionRowSkeleton({ rows }) {
  return (
    <>
      {[...Array(rows)].map((_, r) => (
        <section className="cl-row" key={r} aria-hidden="true">
          <div className="cl-rhead">
            <div>
              <Skeleton w={r % 2 ? 180 : 232} h={20} />
              <span style={{ display: 'block', marginTop: 9 }}>
                <Skeleton w={300} h={12} />
              </span>
              <span style={{ display: 'block', marginTop: 8 }}>
                <Skeleton w={72} h={11} />
              </span>
            </div>
            <Skeleton w={104} h={13} />
          </div>
          <div className="cl-rprods">
            {[...Array(COLL_ROW_PRODUCTS)].map((__, i) => <ProductCardSkeleton key={i} />)}
          </div>
        </section>
      ))}
    </>
  );
}

CollectionRowSkeleton.propTypes = { rows: PropTypes.number };
CollectionRowSkeleton.defaultProps = { rows: 2 };
